import React from 'react'
import {graphql} from 'gatsby'
import LegalPageTemplate from '../../components/templates/legal/LegalPageTemplate'

const PrivacyPolicyPrivateAIPage = ({data}) => {
    return <LegalPageTemplate data={data} />
}

export const query = graphql`
  query PrivacyPolicyPrivateAIPageQuery($language: String = "en") {
    markdownRemark(
      frontmatter: {
        type: {eq: "privacy-privateai"}
        language: {eq: $language}
      }
    ) {
      html
      frontmatter {
        title
        language
        type
        lastUpdated
      }
    }
  }
`

export default PrivacyPolicyPrivateAIPage

